// Define variables
const tabActive = document.querySelectorAll('.tabs.tabs-active button');
const tabLabels = document.querySelectorAll('.tabs button');
const tabPanes = document.getElementsByClassName('tab-content');

// Add 'active' class to the first tab initially if tabPanes[0] exists
if (tabPanes || tabActive) {
    tabActive[0].classList.add('active');
    tabPanes[0].classList.add('active');
}

function activateTab(e) {
    const { target } = e;
    const { classList } = target;
    e.preventDefault();

    // Deactivate all tabs
    tabLabels.forEach(function(label){
        label.classList.remove('active');
    });

    Array.from(tabPanes).forEach(function(pane, index){
        pane.classList.remove('active');
    });

    // Activate current tab

    if(!classList.contains('popup-open')) {
        classList.add('active');
    }

    const clickedTab = target.getAttribute('aria-controls');
    const targetTabPane = document.querySelector('#' + clickedTab);

    // Check if the targetTabPane exists before trying to manipulate its classList
    if (targetTabPane) {
        targetTabPane.classList.add('active');
    }

    if(classList.contains('popup-open')){
        tabActive.forEach(tab => {
            if(tab.textContent === target.textContent) {
                tab.classList.add('active');
            }
        });
    }
}

// Apply event listeners
if(tabPanes) {
    tabLabels.forEach(function (label, index) {
        label.addEventListener('click', activateTab);
    });
}